import experiment from 'experiment';
import { BaseEntryScope } from '#packages/apilib';
import { EditorAPIKey, WorkspaceApiKey } from '#packages/apis';

import { createSlotOpenerPrivateApi } from './privateApi';
import { SlotOpenerStore } from './slotOpenerStoreV2';
import * as store from './slotOpenerStore';

export class SlotOpenerScope extends BaseEntryScope {
  editorAPI = this.useDependency(EditorAPIKey);
  workspaceApi = this.useDependency(WorkspaceApiKey);

  slotOpenerPrivateApi = this.declareApi(createSlotOpenerPrivateApi);
  store = experiment.isOpen('se_slotOpenerV2')
    ? this.declareStore(SlotOpenerStore)
    : store;
}
